export default __webpack_public_path__ + "src/images/packages/saseka-tented-camp/8ae6a651fa5be6c5f44b86d309899410-2.jpg";